export default "__VITE_PUBLIC_ASSET__f7ec72fa__"